import css, { SerializedStyles } from '@emotion/css';
import styled from '@emotion/styled';
import { CircularProgress } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const cssDisplayBlock = css({
  display: 'block',
});
export const cssMarginRight = (theme: ICustomTheme): SerializedStyles =>
  css({
    marginRight: theme.spacing(1),
  });
export const cssVoteButton = (theme: ICustomTheme): SerializedStyles =>
  css({
    borderRadius: theme.shape.borderRadius * 5,
    textTransform: 'none',
  });

export const StyledCircularProgress = styled(CircularProgress)<{
  theme: ICustomTheme;
}>(({ theme }) => ({
  color: theme.colors.white,
  marginRight: theme.spacing(1),
}));
